module.exports = __webpack_public_path__ + "media/packs/images/panes/conversations-4f48b899dd594fc674666f056cfa8bcf.svg";